import { AnomaliesPage } from 'features/anomalies';

export const AdminAnomaliesPage: React.FC = () => <AnomaliesPage />;
